// Từ điển thuật ngữ SEO dùng cho trang "Thuật ngữ" (/glossary).
// Data-driven: thêm 1 thuật ngữ = thêm 1 object vào category tương ứng.
//
// Mỗi thuật ngữ:
//  - term    : tên hiển thị (thường viết tắt hoặc tên tiếng Anh phổ biến).
//  - full    : tên đầy đủ / dịch nghĩa ngắn (hiện dưới tên, có thể bỏ trống).
//  - aliases : các cách gọi khác — dùng để TÌM KIẾM (không hiển thị).
//  - short   : định nghĩa 1 câu, dễ hiểu cho người mới.
//  - detail  : giải thích kỹ hơn (vì sao quan trọng / đọc con số thế nào).
//  - example : ví dụ minh hoạ cụ thể (tuỳ chọn).
//
// Mỗi category: {key, label, icon (FontAwesome), desc, terms: []}.

export const GLOSSARY = [
	{
		key: 'keyword',
		label: 'Từ khoá',
		icon: 'fa-light fa-key',
		desc: 'Các chỉ số khi nghiên cứu từ khoá — dùng ở Nghiên cứu từ khoá, Google Ads, Google Trends.',
		terms: [
			{
				term: 'Từ khoá (Keyword)',
				aliases: 'keyword tu khoa',
				short: 'Cụm từ người dùng gõ vào Google để tìm kiếm.',
				detail: 'Toàn bộ SEO xoay quanh việc trang của bạn xuất hiện khi ai đó tìm một từ khoá liên quan. Chọn đúng từ khoá = chọn đúng khách hàng muốn nhắm tới.',
				example: '"giày chạy bộ nam", "cách làm bánh flan".',
			},
			{
				term: 'Volume',
				full: 'Search Volume — Lượng tìm kiếm',
				aliases: 'volume search volume luong tim kiem',
				short: 'Số lần trung bình một từ khoá được tìm kiếm mỗi tháng.',
				detail: 'Volume càng cao nghĩa là càng nhiều người quan tâm — cơ hội lớn nhưng thường cạnh tranh cao. Volume thấp thì ít lượt tìm nhưng dễ lên top hơn. Đây là con số ước lượng trung bình theo tháng, không phải chính xác từng ngày.',
				example: 'Volume 12.000 = mỗi tháng có khoảng 12.000 lượt tìm từ khoá đó.',
			},
			{
				term: 'CPC',
				full: 'Cost Per Click — Giá mỗi lượt nhấp',
				aliases: 'cpc cost per click gia moi luot nhap quang cao',
				short: 'Số tiền trung bình nhà quảng cáo phải trả cho mỗi lượt nhấp vào quảng cáo của từ khoá đó.',
				detail: 'CPC cao thường báo hiệu từ khoá có "giá trị thương mại" — người tìm sẵn sàng mua hàng, nên nhiều doanh nghiệp tranh nhau chạy quảng cáo. Dù bạn làm SEO (không chạy ads), CPC vẫn giúp đánh giá từ khoá nào đáng đầu tư.',
				example: 'CPC 15.000đ = mỗi cú nhấp quảng cáo tốn khoảng 15.000đ.',
			},
			{
				term: 'KD',
				full: 'Keyword Difficulty — Độ khó từ khoá',
				aliases: 'kd keyword difficulty do kho tu khoa',
				short: 'Mức độ khó để lên top Google cho một từ khoá, thang điểm 0–100.',
				detail: 'Điểm càng cao thì càng nhiều website mạnh đang cạnh tranh, bạn càng khó chen lên trang 1. Người mới nên ưu tiên từ khoá KD thấp (dễ thắng) trước khi đánh những từ khoá KD cao.',
				example: 'KD 0–30 dễ · 30–60 trung bình · 60–100 rất khó.',
			},
			{
				term: 'Competition',
				full: 'Mức độ cạnh tranh (quảng cáo)',
				aliases: 'competition canh tranh',
				short: 'Mức độ cạnh tranh của từ khoá trong quảng cáo Google Ads (thấp / trung bình / cao).',
				detail: 'Khác với KD (cạnh tranh SEO tự nhiên), Competition đo mức tranh giành ở mảng quảng cáo trả tiền. Cùng với CPC, nó cho thấy từ khoá có "máu thương mại" hay không.',
			},
			{
				term: 'Long-tail keyword',
				full: 'Từ khoá dài',
				aliases: 'long tail keyword tu khoa dai',
				short: 'Từ khoá dài, cụ thể (3+ từ), volume thấp nhưng dễ lên top và đúng nhu cầu.',
				detail: 'Người mới nên bắt đầu từ đây: ít cạnh tranh, tỉ lệ chuyển đổi cao vì người tìm biết rõ họ muốn gì.',
				example: '"giày chạy bộ nam đế êm giá rẻ" (long-tail) thay vì "giày" (từ khoá ngắn).',
			},
		],
	},
	{
		key: 'gsc',
		label: 'Google Search Console',
		icon: 'fa-light fa-magnifying-glass-chart',
		desc: 'Chỉ số dữ liệu tìm kiếm thật lấy từ Google Search Console (GSC) — hiệu suất trang của bạn trên Google.',
		terms: [
			{
				term: 'Impressions',
				full: 'Lượt hiển thị',
				aliases: 'impressions luot hien thi',
				short: 'Số lần trang của bạn XUẤT HIỆN trong kết quả tìm kiếm của Google (dù người ta có nhấp hay không).',
				detail: 'Mỗi khi ai đó tìm kiếm và trang bạn hiện ra trong danh sách kết quả, tính là 1 impression — kể cả khi họ không nhấp vào. Impressions cao mà ít nhấp thường có nghĩa: bạn xuất hiện nhưng tiêu đề/mô tả chưa đủ hấp dẫn, hoặc thứ hạng còn thấp.',
				example: 'Trang hiện ở vị trí 8 khi ai đó tìm "váy dạ hội" → +1 impression.',
			},
			{
				term: 'Clicks',
				full: 'Lượt nhấp',
				aliases: 'clicks luot nhap click',
				short: 'Số lần người dùng thực sự NHẤP vào trang của bạn từ kết quả tìm kiếm.',
				detail: 'Đây là lưu lượng thật đổ về website từ Google. Mục tiêu cuối của SEO là tăng con số này bằng cách lên hạng cao hơn và viết tiêu đề hấp dẫn hơn.',
			},
			{
				term: 'CTR',
				full: 'Click-Through Rate — Tỉ lệ nhấp',
				aliases: 'ctr click through rate ti le nhap',
				short: 'Tỉ lệ phần trăm số người NHẤP so với số người THẤY trang của bạn (Clicks ÷ Impressions).',
				detail: 'CTR cho biết tiêu đề và mô tả của bạn có đủ hấp dẫn để "kéo" người ta nhấp vào không. CTR thấp bất thường (dù thứ hạng tốt) là tín hiệu nên viết lại tiêu đề/meta description.',
				example: '100 lượt hiển thị, 5 lượt nhấp → CTR = 5%.',
			},
			{
				term: 'Position',
				full: 'Vị trí trung bình',
				aliases: 'position vi tri trung binh average position rank',
				short: 'Thứ hạng trung bình của trang bạn trên trang kết quả Google cho một từ khoá.',
				detail: 'Số CÀNG NHỎ CÀNG TỐT: vị trí 1 là đứng đầu. Vị trí 1–10 = trang 1 của Google (nơi hầu hết lượt nhấp xảy ra). Vị trí 11–20 = trang 2. Đây là số trung bình nên có thể là 5,4 chẳng hạn.',
				example: 'Position 3,2 nghĩa là trang bạn thường đứng khoảng thứ 3.',
			},
			{
				term: 'Query',
				full: 'Truy vấn',
				aliases: 'query truy van',
				short: 'Cụm từ thực tế mà người dùng đã gõ để tìm ra trang của bạn.',
				detail: 'GSC cho bạn xem danh sách query thật — nhờ đó phát hiện những từ khoá bạn đang lên hạng mà không ngờ tới, để tối ưu thêm.',
			},
			{
				term: 'Cannibalization',
				full: 'Ăn thịt từ khoá',
				aliases: 'cannibalization an thit tu khoa',
				short: 'Khi nhiều trang trên cùng website cùng cạnh tranh một từ khoá, khiến Google bối rối và cả hai đều tụt hạng.',
				detail: 'Nên gộp hoặc phân biệt rõ nội dung các trang trùng chủ đề để dồn "sức mạnh" vào một trang duy nhất.',
			},
		],
	},
	{
		key: 'serp',
		label: 'Thứ hạng & SERP',
		icon: 'fa-light fa-ranking-star',
		desc: 'Thuật ngữ về vị trí trên trang kết quả tìm kiếm và theo dõi thứ hạng.',
		terms: [
			{
				term: 'SERP',
				full: 'Search Engine Results Page — Trang kết quả tìm kiếm',
				aliases: 'serp search engine results page trang ket qua',
				short: 'Trang mà Google hiển thị sau khi bạn tìm kiếm — danh sách các link kết quả.',
				detail: 'Mục tiêu SEO là đưa trang của bạn lên cao trong SERP. Ngoài 10 link "xanh" quen thuộc, SERP còn có quảng cáo, hộp trả lời nhanh, hình ảnh, video...',
			},
			{
				term: 'Organic',
				full: 'Kết quả tự nhiên',
				aliases: 'organic tu nhien ket qua tu nhien',
				short: 'Kết quả tìm kiếm KHÔNG phải quảng cáo — có được nhờ SEO, không phải trả tiền.',
				detail: 'Đối lập với "Paid" (quảng cáo trả phí). Lưu lượng organic là "miễn phí" và bền vững — đích đến của mọi chiến dịch SEO.',
			},
			{
				term: 'Ranking / Position',
				full: 'Thứ hạng',
				aliases: 'ranking position thu hang xep hang',
				short: 'Vị trí trang của bạn đứng trên SERP cho một từ khoá (1 = cao nhất).',
				detail: 'Công cụ Theo dõi thứ hạng đo vị trí THẬT theo thiết bị (máy tính/điện thoại) và quốc gia — khác với "vị trí trung bình" của GSC.',
			},
			{
				term: 'SERP features',
				full: 'Thành phần đặc biệt trên SERP',
				aliases: 'serp features featured snippet doan trich noi bat',
				short: 'Các khối đặc biệt Google chèn vào kết quả: hộp trả lời nhanh, "Mọi người cũng hỏi", hình ảnh, đánh giá sao...',
				detail: 'Featured snippet (đoạn trích nổi bật) là khối trả lời hiện ngay đầu trang — chiếm được nó giúp bạn "vượt mặt" cả vị trí số 1.',
			},
			{
				term: 'Impression share / Best rank',
				full: 'Hạng tốt nhất',
				aliases: 'best rank hang tot nhat',
				short: 'Thứ hạng cao nhất mà một từ khoá của bạn từng đạt được trong khoảng thời gian theo dõi.',
				detail: 'Giúp bạn biết trang có tiềm năng lên tới đâu, kể cả khi hiện tại đang tụt.',
			},
		],
	},
	{
		key: 'backlink',
		label: 'Backlink',
		icon: 'fa-light fa-link',
		desc: 'Thuật ngữ về liên kết từ website khác trỏ về trang của bạn — yếu tố "uy tín" quan trọng của SEO.',
		terms: [
			{
				term: 'Backlink',
				full: 'Liên kết trỏ về',
				aliases: 'backlink lien ket tro ve inbound link',
				short: 'Một đường link từ website KHÁC trỏ về trang của bạn.',
				detail: 'Google coi mỗi backlink như một "phiếu bầu tín nhiệm": càng nhiều website uy tín dẫn link về bạn, Google càng tin trang bạn giá trị và xếp hạng cao hơn. Chất lượng quan trọng hơn số lượng.',
			},
			{
				term: 'Referring domains',
				full: 'Số tên miền trỏ về',
				aliases: 'referring domains ten mien tro ve',
				short: 'Số lượng website (tên miền) KHÁC NHAU có link trỏ về bạn.',
				detail: 'Quan trọng hơn tổng số backlink: 100 link từ 1 website chỉ tính là 1 referring domain, kém giá trị hơn 100 link từ 100 website khác nhau.',
			},
			{
				term: 'Anchor text',
				full: 'Văn bản neo',
				aliases: 'anchor text van ban neo chu chua link',
				short: 'Đoạn chữ được gắn link mà người ta nhấp vào.',
				detail: 'Anchor text giúp Google hiểu trang được link nói về chủ đề gì. Anchor chứa từ khoá liên quan sẽ có lợi, nhưng lạm dụng nhồi từ khoá lại bị phạt.',
				example: 'Trong câu "xem thêm giày chạy bộ tại đây", chữ được gạch chân/tô màu là anchor text.',
			},
			{
				term: 'Dofollow / Nofollow',
				aliases: 'dofollow nofollow',
				short: 'Dofollow = link "truyền uy tín" cho trang đích; Nofollow = link bảo Google "đừng tính phiếu bầu".',
				detail: 'Backlink dofollow mới thực sự giúp tăng thứ hạng. Nofollow (thường dùng ở bình luận, mạng xã hội) vẫn có ích cho traffic nhưng ít giá trị SEO trực tiếp.',
			},
			{
				term: 'Domain Rank / DA',
				full: 'Domain Authority — Độ uy tín tên miền',
				aliases: 'domain rank da domain authority do uy tin ten mien',
				short: 'Điểm đánh giá "sức mạnh" tổng thể của một website, thang 0–100.',
				detail: 'Điểm càng cao thì website càng uy tín và dễ lên top. Đây là chỉ số của bên thứ ba (không phải của Google), dùng để so sánh tương đối giữa bạn và đối thủ.',
			},
			{
				term: 'Spam Score',
				full: 'Điểm rác',
				aliases: 'spam score diem rac',
				short: 'Mức độ "đáng ngờ" của một website — càng cao càng dễ là web rác/kém chất lượng.',
				detail: 'Backlink từ website có spam score cao có thể gây hại thay vì có lợi. Nên tránh nhận link từ các nguồn này.',
			},
			{
				term: 'New / Lost links',
				full: 'Link mới / Link mất',
				aliases: 'new lost links link moi link mat',
				short: 'Số backlink bạn mới nhận được / bị mất đi trong một khoảng thời gian.',
				detail: 'Theo dõi để biết chiến dịch xây link có hiệu quả không, và cảnh báo khi bị mất link quan trọng.',
			},
		],
	},
	{
		key: 'speed',
		label: 'Tốc độ & Core Web Vitals',
		icon: 'fa-light fa-gauge-high',
		desc: 'Chỉ số về tốc độ và trải nghiệm tải trang — Google dùng để xếp hạng (đo qua PageSpeed).',
		terms: [
			{
				term: 'Core Web Vitals',
				full: 'Các chỉ số web cốt lõi',
				aliases: 'core web vitals cwv',
				short: 'Bộ 3 chỉ số Google dùng để đo trải nghiệm người dùng: tốc độ tải, độ phản hồi, độ ổn định giao diện.',
				detail: 'Gồm LCP, INP và CLS. Đạt "tốt" cả ba giúp trang được Google ưu ái hơn và giữ chân khách tốt hơn.',
			},
			{
				term: 'LCP',
				full: 'Largest Contentful Paint — Thời gian hiển thị nội dung lớn nhất',
				aliases: 'lcp largest contentful paint',
				short: 'Thời gian để phần nội dung lớn nhất (thường là ảnh/tiêu đề chính) hiện ra trên màn hình.',
				detail: 'Đo cảm giác "trang tải xong chưa". Mục tiêu: dưới 2,5 giây là tốt.',
				example: 'LCP 2,1s = tốt · 2,5–4s = cần cải thiện · trên 4s = kém.',
			},
			{
				term: 'INP',
				full: 'Interaction to Next Paint — Độ phản hồi tương tác',
				aliases: 'inp interaction to next paint fid',
				short: 'Thời gian trang phản hồi sau khi người dùng nhấp/gõ/chạm (thay thế chỉ số FID cũ).',
				detail: 'Đo độ "mượt" khi tương tác. Mục tiêu: dưới 200 mili-giây. INP cao khiến người dùng thấy trang bị "lag".',
			},
			{
				term: 'CLS',
				full: 'Cumulative Layout Shift — Độ dịch chuyển bố cục',
				aliases: 'cls cumulative layout shift',
				short: 'Mức độ giao diện bị "nhảy/xê dịch" bất ngờ trong lúc tải trang.',
				detail: 'Bạn từng định bấm nút rồi trang nhảy làm bấm nhầm? Đó là CLS cao. Mục tiêu: dưới 0,1.',
			},
			{
				term: 'FCP',
				full: 'First Contentful Paint — Hiển thị nội dung đầu tiên',
				aliases: 'fcp first contentful paint',
				short: 'Thời gian đến khi bất kỳ nội dung đầu tiên nào (chữ, ảnh) xuất hiện trên màn hình.',
				detail: 'Cho biết người dùng phải chờ bao lâu mới thấy trang "có gì đó" thay vì màn hình trắng.',
			},
			{
				term: 'TTFB',
				full: 'Time To First Byte — Thời gian đến byte đầu tiên',
				aliases: 'ttfb time to first byte',
				short: 'Thời gian máy chủ bắt đầu phản hồi sau khi trình duyệt gửi yêu cầu.',
				detail: 'TTFB cao thường do máy chủ/hosting chậm. Là điểm khởi đầu ảnh hưởng tới mọi chỉ số tốc độ khác.',
			},
			{
				term: 'Lab data / Field data',
				full: 'Dữ liệu phòng lab / thực tế',
				aliases: 'lab data field data du lieu phong lab thuc te',
				short: 'Lab = đo trong môi trường mô phỏng chuẩn; Field = dữ liệu thật từ người dùng thật.',
				detail: 'Field data phản ánh trải nghiệm thực nhưng cần đủ lượng truy cập mới có. Lab data luôn có sẵn, dùng để gỡ lỗi.',
			},
		],
	},
	{
		key: 'technical',
		label: 'Kỹ thuật SEO',
		icon: 'fa-light fa-gears',
		desc: 'Thuật ngữ kỹ thuật về việc Google thu thập, lập chỉ mục và hiểu website — dùng ở Site Crawler & Kỹ thuật SEO.',
		terms: [
			{
				term: 'Crawl',
				full: 'Thu thập dữ liệu',
				aliases: 'crawl thu thap du lieu bo crawl',
				short: 'Việc "con bọ" của Google (hoặc công cụ này) tự động đi qua từng trang web để đọc nội dung.',
				detail: 'Google phải crawl được trang thì mới biết trang tồn tại. Công cụ Site Crawler cũng crawl website của bạn để chấm điểm từng trang.',
			},
			{
				term: 'Index',
				full: 'Lập chỉ mục',
				aliases: 'index lap chi muc',
				short: 'Việc Google lưu trang của bạn vào "kho dữ liệu" để có thể hiển thị khi ai đó tìm kiếm.',
				detail: 'Crawl xong chưa chắc được index. Trang chưa được index sẽ KHÔNG BAO GIỜ xuất hiện trên Google, dù nội dung tốt đến đâu.',
			},
			{
				term: 'Robots.txt',
				aliases: 'robots txt robots.txt',
				short: 'Một tệp nhỏ ở gốc website báo cho các bot biết được phép/không được phép truy cập những phần nào.',
				detail: 'Cấu hình sai robots.txt có thể vô tình chặn Google crawl cả website → mất sạch thứ hạng. Cần kiểm tra cẩn thận.',
			},
			{
				term: 'Sitemap',
				full: 'Sơ đồ website',
				aliases: 'sitemap so do website xml',
				short: 'Danh sách (thường là tệp XML) liệt kê mọi trang quan trọng để Google dễ tìm và crawl.',
				detail: 'Giống "bản đồ" giúp Google không bỏ sót trang nào. Nên khai báo sitemap trong Google Search Console.',
			},
			{
				term: 'Canonical',
				full: 'Thẻ chuẩn hoá',
				aliases: 'canonical the chuan hoa url chinh',
				short: 'Thẻ báo cho Google biết đâu là phiên bản "chính thức" khi có nhiều URL nội dung giống nhau.',
				detail: 'Tránh bị đánh giá là nội dung trùng lặp (duplicate) và giúp dồn sức mạnh về đúng một URL.',
			},
			{
				term: 'Redirect (301/302)',
				full: 'Chuyển hướng',
				aliases: 'redirect chuyen huong 301 302',
				short: 'Tự động đưa người dùng từ URL này sang URL khác. 301 = chuyển vĩnh viễn, 302 = tạm thời.',
				detail: 'Khi đổi/xoá URL, dùng 301 để giữ lại thứ hạng và không tạo lỗi 404. Chuỗi redirect quá dài làm chậm trang.',
			},
			{
				term: 'Broken link',
				full: 'Liên kết hỏng',
				aliases: 'broken link lien ket hong 404 loi',
				short: 'Đường link trỏ tới trang không còn tồn tại (thường trả lỗi 404).',
				detail: 'Link hỏng gây trải nghiệm xấu và làm lãng phí "ngân sách crawl" của Google. Nên sửa hoặc gỡ bỏ.',
			},
			{
				term: 'Orphan page',
				full: 'Trang mồ côi',
				aliases: 'orphan page trang mo coi',
				short: 'Trang tồn tại nhưng KHÔNG có trang nào khác trong website link tới nó.',
				detail: 'Vì không có đường dẫn nội bộ, cả người dùng lẫn Google đều khó tìm ra → trang gần như "vô hình". Nên thêm internal link trỏ về.',
			},
			{
				term: 'X-Robots-Tag',
				aliases: 'x-robots-tag x robots tag noindex',
				short: 'Chỉ dẫn (đặt trong header máy chủ) cho Google biết có được index/follow trang hay không.',
				detail: 'Tương tự thẻ meta robots nhưng ở cấp máy chủ — hữu ích để chặn index cho tệp PDF, ảnh...',
			},
			{
				term: 'Schema / Structured data',
				full: 'Dữ liệu có cấu trúc (JSON-LD)',
				aliases: 'schema structured data json-ld du lieu co cau truc',
				short: 'Đoạn mã ẩn giúp Google hiểu rõ nội dung trang (đây là sản phẩm, công thức nấu ăn, câu hỏi FAQ...).',
				detail: 'Khai báo schema đúng giúp trang được hiển thị "rich result" đẹp mắt trên Google: giá, đánh giá sao, ảnh, câu hỏi — tăng CTR đáng kể. Công cụ Schema.org giúp bạn tạo & kiểm tra.',
			},
		],
	},
	{
		key: 'content',
		label: 'Nội dung & On-page',
		icon: 'fa-light fa-file-lines',
		desc: 'Thuật ngữ về tối ưu ngay trên trang: tiêu đề, mô tả, liên kết nội bộ, hình ảnh.',
		terms: [
			{
				term: 'Meta title',
				full: 'Thẻ tiêu đề',
				aliases: 'meta title the tieu de title tag',
				short: 'Tiêu đề của trang hiển thị dạng dòng chữ xanh có thể nhấp trên kết quả Google.',
				detail: 'Yếu tố on-page quan trọng bậc nhất. Nên chứa từ khoá chính, hấp dẫn và dài khoảng 50–60 ký tự để không bị cắt.',
			},
			{
				term: 'Meta description',
				full: 'Thẻ mô tả',
				aliases: 'meta description the mo ta',
				short: 'Đoạn mô tả ngắn hiện dưới tiêu đề trên kết quả Google.',
				detail: 'Không trực tiếp giúp lên hạng nhưng ảnh hưởng lớn tới CTR — một mô tả hấp dẫn khiến người ta nhấp vào bạn thay vì đối thủ. Khoảng 150–160 ký tự.',
			},
			{
				term: 'Internal link',
				full: 'Liên kết nội bộ',
				aliases: 'internal link lien ket noi bo',
				short: 'Đường link từ một trang tới một trang KHÁC trong cùng website của bạn.',
				detail: 'Giúp người dùng và Google di chuyển giữa các trang, đồng thời truyền "sức mạnh" cho những trang quan trọng. Trang thiếu internal link dễ thành "trang mồ côi".',
			},
			{
				term: 'Alt text',
				full: 'Văn bản thay thế cho ảnh',
				aliases: 'alt text van ban thay the anh alt',
				short: 'Đoạn mô tả nội dung của một hình ảnh, dành cho Google và người khiếm thị.',
				detail: 'Google không "nhìn" được ảnh, nó đọc alt text để hiểu ảnh về gì — giúp ảnh của bạn lên top tìm kiếm hình ảnh và cải thiện SEO tổng thể.',
			},
			{
				term: 'Content gap',
				full: 'Khoảng trống nội dung',
				aliases: 'content gap khoang trong noi dung',
				short: 'Những từ khoá/chủ đề mà đối thủ có nội dung còn bạn thì chưa.',
				detail: 'Phân tích content gap chỉ ra chính xác bạn nên viết thêm bài gì để bắt kịp và vượt đối thủ.',
			},
			{
				term: 'E-E-A-T',
				full: 'Experience, Expertise, Authoritativeness, Trust',
				aliases: 'eeat e-e-a-t kinh nghiem chuyen mon uy tin',
				short: 'Bộ tiêu chí Google đánh giá độ tin cậy: Trải nghiệm, Chuyên môn, Thẩm quyền, Đáng tin cậy.',
				detail: 'Đặc biệt quan trọng với chủ đề sức khoẻ, tài chính. Thể hiện tác giả có chuyên môn, thông tin có nguồn, website minh bạch sẽ được Google tin tưởng hơn.',
			},
			{
				term: 'Duplicate content',
				full: 'Nội dung trùng lặp',
				aliases: 'duplicate content noi dung trung lap',
				short: 'Nội dung giống hoặc gần giống nhau xuất hiện ở nhiều URL.',
				detail: 'Khiến Google bối rối không biết xếp hạng trang nào, làm loãng sức mạnh. Xử lý bằng thẻ canonical hoặc viết lại nội dung.',
			},
		],
	},
	{
		key: 'analytics',
		label: 'Google Analytics (GA4)',
		icon: 'fa-light fa-chart-line',
		desc: 'Chỉ số về hành vi người dùng trên website, lấy từ Google Analytics 4.',
		terms: [
			{
				term: 'Sessions',
				full: 'Phiên truy cập',
				aliases: 'sessions phien truy cap',
				short: 'Một lượt người dùng ghé thăm và tương tác với website trong một khoảng thời gian.',
				detail: 'Một người có thể tạo nhiều phiên (ghé sáng rồi ghé tối). Phiên kết thúc sau 30 phút không hoạt động.',
			},
			{
				term: 'Users',
				full: 'Người dùng',
				aliases: 'users nguoi dung',
				short: 'Số người dùng KHÁC NHAU đã ghé thăm website.',
				detail: 'Khác với Sessions: 1 user có thể tạo nhiều session. "New users" là người lần đầu ghé thăm.',
			},
			{
				term: 'Engagement rate',
				full: 'Tỉ lệ tương tác',
				aliases: 'engagement rate ti le tuong tac',
				short: 'Tỉ lệ phần trăm phiên truy cập có tương tác thực sự (ở lại lâu, xem nhiều trang, hoặc chuyển đổi).',
				detail: 'Càng cao càng tốt — cho thấy nội dung thu hút, giữ chân được người dùng. Đây là chỉ số hiện đại thay cho "bounce rate".',
			},
			{
				term: 'Bounce rate',
				full: 'Tỉ lệ thoát',
				aliases: 'bounce rate ti le thoat',
				short: 'Tỉ lệ phần trăm phiên KHÔNG có tương tác (vào rồi thoát ngay).',
				detail: 'Ngược với engagement rate. Bounce cao có thể do nội dung không đúng ý người tìm, hoặc trang tải chậm.',
			},
			{
				term: 'Key events / Conversions',
				full: 'Sự kiện quan trọng / Chuyển đổi',
				aliases: 'key events conversions chuyen doi su kien quan trong',
				short: 'Những hành động giá trị bạn muốn người dùng thực hiện: mua hàng, điền form, gọi điện...',
				detail: 'Đích cuối cùng của mọi hoạt động SEO/marketing. Đo được conversion mới biết SEO có mang lại doanh thu thật hay không.',
			},
		],
	},
	{
		key: 'ai',
		label: 'AI & GEO',
		icon: 'fa-light fa-robot',
		desc: 'Thuật ngữ mới về tối ưu cho các công cụ tìm kiếm dùng AI (ChatGPT, Google AI, Perplexity...).',
		terms: [
			{
				term: 'GEO',
				full: 'Generative Engine Optimization — Tối ưu cho công cụ AI',
				aliases: 'geo generative engine optimization toi uu ai',
				short: 'Tối ưu nội dung để được các công cụ AI (ChatGPT, Google AI Overviews, Perplexity) trích dẫn khi trả lời.',
				detail: 'Phần mở rộng của SEO cho kỷ nguyên AI: thay vì chỉ lên top Google, bạn muốn AI chọn website bạn làm nguồn thông tin. Cần nội dung rõ ràng, có cấu trúc, dữ kiện đáng tin.',
			},
			{
				term: 'llms.txt',
				aliases: 'llms txt llms.txt',
				short: 'Một tệp chuẩn mới (giống robots.txt) hướng dẫn các mô hình AI cách đọc và dùng nội dung website của bạn.',
				detail: 'Giúp các công cụ AI hiểu đúng và ưu tiên nội dung quan trọng. Công cụ Kỹ thuật SEO có thể tự sinh tệp này cho bạn.',
			},
			{
				term: 'AI bots',
				full: 'Bot của các công cụ AI',
				aliases: 'ai bots gptbot perplexitybot claudebot',
				short: 'Các "con bọ" thu thập dữ liệu của công cụ AI (GPTBot, PerplexityBot, ClaudeBot...).',
				detail: 'Nếu robots.txt chặn các bot này, nội dung của bạn sẽ không bao giờ được AI trích dẫn. Cần cân nhắc mở/chặn tuỳ chiến lược.',
			},
			{
				term: 'Answer structure',
				full: 'Cấu trúc trả lời',
				aliases: 'answer structure cau truc tra loi chunkability',
				short: 'Cách tổ chức nội dung rõ ràng (tiêu đề dạng câu hỏi, danh sách, bảng) để AI dễ trích ra câu trả lời.',
				detail: 'Nội dung chia khối gọn gàng, mỗi đoạn trả lời trọn một ý sẽ dễ được AI "nhặt" để trả lời người dùng.',
			},
		],
	},
];

// Tổng số thuật ngữ — hiện ở tiêu đề trang.
export const GLOSSARY_COUNT = GLOSSARY.reduce((n, c) => n + c.terms.length, 0);
